import { baseColors } from './base-colors';

export const colorFromMetricId: Record<string, string> = {
  availability: baseColors[4],
  availability_pcs: baseColors[5],
  rte: baseColors[12],
  soh: baseColors[14],
  capacity: baseColors[8],
};
